export { default } from "./DetailsMarkup";
